import React from "react";

export function UncheckedBox({ fillColor = "#0369E0" }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 1.5H14.25C15.4926 1.5 16.5 2.50736 16.5 3.75V14.25C16.5 15.4926 15.4926 16.5 14.25 16.5H3.75C2.50736 16.5 1.5 15.4926 1.5 14.25V3.75C1.5 2.50736 2.50736 1.5 3.75 1.5ZM3.75 3C3.33579 3 3 3.33579 3 3.75V14.25C3 14.6642 3.33579 15 3.75 15H14.25C14.6642 15 15 14.6642 15 14.25V3.75C15 3.33579 14.6642 3 14.25 3H3.75Z"
        fill={fillColor}
      />
      <mask
        id="uncheckedBoxId"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="16"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 1.5H14.25C15.4926 1.5 16.5 2.50736 16.5 3.75V14.25C16.5 15.4926 15.4926 16.5 14.25 16.5H3.75C2.50736 16.5 1.5 15.4926 1.5 14.25V3.75C1.5 2.50736 2.50736 1.5 3.75 1.5ZM3.75 3C3.33579 3 3 3.33579 3 3.75V14.25C3 14.6642 3.33579 15 3.75 15H14.25C14.6642 15 15 14.6642 15 14.25V3.75C15 3.33579 14.6642 3 14.25 3H3.75Z"
          fill="white"
        />
      </mask>
      <g mask="url(#uncheckedBoxId)">
        <rect width="18" height="18" fill={fillColor} />
      </g>
    </svg>
  );
}
export function CheckedBox({ fillColor = "#0369E0" }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.25 14.25V9C14.25 8.58579 14.5858 8.25 15 8.25C15.4142 8.25 15.75 8.58579 15.75 9V14.25C15.75 15.4926 14.7426 16.5 13.5 16.5H3C1.75736 16.5 0.75 15.4926 0.75 14.25V3.75C0.75 2.50736 1.75736 1.5 3 1.5H11.25C11.6642 1.5 12 1.83579 12 2.25C12 2.66421 11.6642 3 11.25 3H3C2.58579 3 2.25 3.33579 2.25 3.75V14.25C2.25 14.6642 2.58579 15 3 15H13.5C13.9142 15 14.25 14.6642 14.25 14.25ZM6.53033 7.71967L8.25 9.43934L15.9697 1.71967C16.2626 1.42678 16.7374 1.42678 17.0303 1.71967C17.3232 2.01256 17.3232 2.48744 17.0303 2.78033L8.78033 11.0303C8.48744 11.3232 8.01256 11.3232 7.71967 11.0303L5.46967 8.78033C5.17678 8.48744 5.17678 8.01256 5.46967 7.71967C5.76256 7.42678 6.23744 7.42678 6.53033 7.71967Z"
        fill={fillColor}
      />
      <mask
        id="checkedBoxId"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="1"
        width="18"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.25 14.25V9C14.25 8.58579 14.5858 8.25 15 8.25C15.4142 8.25 15.75 8.58579 15.75 9V14.25C15.75 15.4926 14.7426 16.5 13.5 16.5H3C1.75736 16.5 0.75 15.4926 0.75 14.25V3.75C0.75 2.50736 1.75736 1.5 3 1.5H11.25C11.6642 1.5 12 1.83579 12 2.25C12 2.66421 11.6642 3 11.25 3H3C2.58579 3 2.25 3.33579 2.25 3.75V14.25C2.25 14.6642 2.58579 15 3 15H13.5C13.9142 15 14.25 14.6642 14.25 14.25ZM6.53033 7.71967L8.25 9.43934L15.9697 1.71967C16.2626 1.42678 16.7374 1.42678 17.0303 1.71967C17.3232 2.01256 17.3232 2.48744 17.0303 2.78033L8.78033 11.0303C8.48744 11.3232 8.01256 11.3232 7.71967 11.0303L5.46967 8.78033C5.17678 8.48744 5.17678 8.01256 5.46967 7.71967C5.76256 7.42678 6.23744 7.42678 6.53033 7.71967Z"
          fill="white"
        />
      </mask>
      <g mask="url(#checkedBoxId)">
        <rect width="18" height="18" fill={fillColor} />
      </g>
    </svg>
  );
}
